import React from 'react';
import { ConfirmPasswordModal } from '../../Modals';
import DeleteConfirmationForm from './DeleteConfirmationForm';
import BeneficiaryListToDelete from './BeneficiaryListToDelete';
import propTypes from 'prop-types';

function TemplateProfileDelete(props) {
  const {
    showDeleteForm,
    showDeleteName,
    validationCodeSuccess,
    showConfirmationModal,
    validationCodeErrors,
    verificationSteps,
    data,
    benificiaireList,
    code
  } = props;

  const renderContent = () => {
    if (showDeleteForm) {
      return (
        <DeleteConfirmationForm
          onClose={props.onClose}
          step={props.step}
          validationCodeSuccess={validationCodeSuccess}
          beneficiaryName={showDeleteName}
          onConfirmDeletion={props.onConfirmDeletion}
          navigationSteps={props.navigationSteps}
        />
      );
    }

    if (showConfirmationModal) {
      return (
        <ConfirmPasswordModal
          show={showConfirmationModal}
          onHide={props.onHide}
          errorMessages={validationCodeErrors}
          modalStep={verificationSteps}
          success={validationCodeSuccess}
          title="Validation des modifications"
          firstText={`Nous venons d'envoyer un code par email à l'adresse ${data.mail}`}
          secondText="Veuillez le renseigner ci-dessous pour confirmer les modifications :"
          onConfirmCode={props.onConfirmCodeDelete}
          onCancel={props.onHide}
          successText="Vos modifications ont été enregistrées."
          classNameBtncancel="btn-cancel-modal-edit-profile"
          classNameBtnSubmit="btn-submit-modal-edit-profile"
          classNameInput="input-modal-edit-profile"
          onChange={(e) => props.onChangeCode(e.target.value)}
          code={code}
        />
      );
    }

    return (
      <BeneficiaryListToDelete
        beneficiaries={benificiaireList}
        onSelectBeneficiary={props.handelSelectedProfileDelete}
      />
    );
  };

  return <>{renderContent()}</>;

}

TemplateProfileDelete.propTypes = {
  step: propTypes.number,
  showDeleteForm: propTypes.bool,
  showDeleteName: propTypes.string,
  validationCodeSuccess: propTypes.bool,
  showConfirmationModal: propTypes.bool,
  validationCodeErrors: propTypes.array,
  verificationSteps: propTypes.number,
  data: propTypes.array,
  benificiaireList: propTypes.array,
  code: propTypes.string,
  onClose: propTypes.func,
  handelSelectedProfileDelete: propTypes.func,
  onConfirmDeletion: propTypes.func,
  onHide: propTypes.func,
  onConfirmCodeDelete: propTypes.func,
  onChangeCode: propTypes.func,
  navigationSteps: propTypes.any
};

export default TemplateProfileDelete;
